import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col w-full border rounded-xl border-gray-lp-1400 pt-4 font-montserrat" }
const _hoisted_3 = { class: "flex flex-col border-b border-gray-lp-1400 px-4 pb-5" }
const _hoisted_4 = { class: "text-20px text-gray-lp-300 font-bold" }
const _hoisted_5 = { class: "text-14px text-gray-lp-600 font-normal" }
const _hoisted_6 = { class: "mt-5 flex px-4 border-b pb-5" }
const _hoisted_7 = { class: "flex flex-row gap-x-3" }
const _hoisted_8 = { style: {"margin-bottom":"-15px"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("g", { opacity: "0.5" }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "#D4D5D8"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M18.3332 10.0003C18.3332 14.6027 14.6022 18.3337 9.99984 18.3337C5.39746 18.3337 1.6665 14.6027 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003Z",
      fill: "#A7A8AA"
    })
  ])
], -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 18.5872C14.6024 18.5872 18.3333 14.8563 18.3333 10.2539C18.3333 5.65153 14.6024 1.92057 10 1.92057C5.39763 1.92057 1.66667 5.65153 1.66667 10.2539C1.66667 14.8563 5.39763 18.5872 10 18.5872ZM10 20.2539C15.5228 20.2539 20 15.7768 20 10.2539C20 4.73106 15.5228 0.253906 10 0.253906C4.47715 0.253906 0 4.73106 0 10.2539C0 15.7768 4.47715 20.2539 10 20.2539Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("path", {
  d: "M16.6668 10.2541C16.6668 13.936 13.6821 16.9207 10.0002 16.9207C6.31826 16.9207 3.3335 13.936 3.3335 10.2541C3.3335 6.57217 6.31826 3.5874 10.0002 3.5874C13.6821 3.5874 16.6668 6.57217 16.6668 10.2541Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_15 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 18.5872C14.6024 18.5872 18.3333 14.8563 18.3333 10.2539C18.3333 5.65153 14.6024 1.92057 10 1.92057C5.39763 1.92057 1.66667 5.65153 1.66667 10.2539C1.66667 14.8563 5.39763 18.5872 10 18.5872ZM10 20.2539C15.5228 20.2539 20 15.7768 20 10.2539C20 4.73106 15.5228 0.253906 10 0.253906C4.47715 0.253906 0 4.73106 0 10.2539C0 15.7768 4.47715 20.2539 10 20.2539Z",
  fill: "#D4D5D8"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("path", {
  d: "M18.3334 10.2537C18.3334 14.8561 14.6025 18.5871 10.0001 18.5871C5.39771 18.5871 1.66675 14.8561 1.66675 10.2537C1.66675 5.65137 5.39771 1.92041 10.0001 1.92041C14.6025 1.92041 18.3334 5.65137 18.3334 10.2537Z",
  fill: "white"
}, null, -1)
const _hoisted_18 = { class: "flex flex-row gap-x-2 justify-center" }
const _hoisted_19 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("path", {
  d: "M17.9055 3.27183L17.9055 3.27183C17.7425 2.93022 17.2562 2.93022 17.0932 3.27183L16.3241 4.88363L14.5535 5.11703C14.1783 5.16649 14.028 5.62895 14.3025 5.88954L15.5978 7.11908L15.2726 8.87513C15.2037 9.24731 15.5971 9.53312 15.9297 9.35257L17.4994 8.50067L19.069 9.35257C19.4016 9.53312 19.795 9.24731 19.7261 8.87513L19.401 7.11908L20.6962 5.88954C20.9707 5.62895 20.8205 5.16649 20.4452 5.11703L18.6746 4.88363L17.9055 3.27183ZM17.5232 8.48772C17.5232 8.48774 17.5232 8.48776 17.5231 8.48777L17.5232 8.48772ZM19.3813 7.13777L19.3814 7.13768L19.3813 7.13777Z",
  fill: "#1C54C5",
  stroke: "#1C54C5",
  "stroke-width": "0.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.8424 4.65351L18.1318 3.16416C17.8782 2.63278 17.1218 2.63278 16.8682 3.16416L16.1576 4.65351L14.5215 4.86917C13.9378 4.94612 13.704 5.66549 14.131 6.07085L15.3279 7.20698L15.0274 8.82962C14.9202 9.40856 15.5322 9.85315 16.0496 9.57229L17.5 8.78512L18.9504 9.57229C19.4678 9.85315 20.0798 9.40856 19.9726 8.82962L19.6721 7.20698L20.869 6.07085C21.296 5.66549 21.0622 4.94612 20.4785 4.86917L18.8424 4.65351ZM17.6805 3.37949C17.6081 3.22767 17.3919 3.22767 17.3195 3.37949L16.5387 5.01579C16.5095 5.07689 16.4515 5.11909 16.3843 5.12794L14.5868 5.36488C14.4201 5.38687 14.3533 5.5924 14.4753 5.70822L15.7902 6.95645C15.8393 7.00306 15.8615 7.07135 15.8492 7.13792L15.5191 8.92065C15.4884 9.08606 15.6633 9.21309 15.8111 9.13285L17.4046 8.268C17.4641 8.23571 17.5359 8.23571 17.5954 8.268L19.1889 9.13285C19.3367 9.21309 19.5116 9.08606 19.4809 8.92065L19.1508 7.13792C19.1385 7.07135 19.1607 7.00306 19.2098 6.95645L20.5247 5.70822C20.6467 5.5924 20.5799 5.38687 20.4132 5.36488L18.6157 5.12794C18.5485 5.11909 18.4905 5.07689 18.4613 5.01579L17.6805 3.37949Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("path", {
  d: "M12 5.00098C8.13401 5.00098 5 8.13498 5 12.001C5 15.867 8.13401 19.001 12 19.001C15.866 19.001 19 15.867 19 12.001C19 11.4487 19.4477 11.001 20 11.001C20.5523 11.001 21 11.4487 21 12.001C21 16.9715 16.9706 21.001 12 21.001C7.02944 21.001 3 16.9715 3 12.001C3 7.03041 7.02944 3.00098 12 3.00098C12.5523 3.00098 13 3.44869 13 4.00098C13 4.55326 12.5523 5.00098 12 5.00098Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.1822 14.7183C12.1478 14.7844 12.0794 14.8259 12.0049 14.8259H10.6564C10.5908 14.8259 10.5293 14.7937 10.492 14.7397L9.50541 13.3146H8.65547V14.6259C8.65547 14.7363 8.56593 14.8259 8.45547 14.8259H7.2C7.08954 14.8259 7 14.7363 7 14.6259V9.20098C7 9.09052 7.08954 9.00098 7.2 9.00098H9.5482C10.3054 9.00098 10.9443 9.19734 11.3977 9.57532C11.8553 9.9568 12.1041 10.5074 12.1041 11.1694C12.1041 11.9763 11.7305 12.5997 11.0856 12.9588L12.1689 14.5114C12.2116 14.5725 12.2167 14.6523 12.1822 14.7183ZM10.215 10.6261C10.0712 10.5054 9.83532 10.424 9.47845 10.424H8.65547V11.9149H9.47845C9.83432 11.9149 10.0703 11.8319 10.2145 11.7102C10.3535 11.5929 10.4332 11.4176 10.4332 11.1694C10.4332 10.9168 10.3531 10.7421 10.215 10.6261Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.0133 10.4925V10.4564C14.0133 10.346 13.9238 10.2564 13.8133 10.2564H12.6586C12.5481 10.2564 12.4586 10.346 12.4586 10.4564V16.1293C12.4586 16.2398 12.5481 16.3293 12.6586 16.3293H13.8676C13.978 16.3293 14.0676 16.2398 14.0676 16.1293V14.6106C14.3685 14.7994 14.7262 14.8879 15.123 14.8879C15.7567 14.8879 16.3282 14.6606 16.7418 14.2471C17.1558 13.833 17.4 13.2437 17.4 12.5412C17.4 11.8386 17.1558 11.2493 16.7418 10.8352C16.3282 10.4217 15.7567 10.1944 15.123 10.1944C14.7006 10.1944 14.3222 10.29 14.0133 10.4925ZM15.5268 13.2506C15.6756 13.0949 15.7755 12.8585 15.7755 12.5412C15.7755 12.2238 15.6756 11.9874 15.5268 11.8317C15.3782 11.6763 15.1668 11.5864 14.9138 11.5864C14.6608 11.5864 14.4494 11.6763 14.3008 11.8317C14.152 11.9874 14.0521 12.2238 14.0521 12.5412C14.0521 12.8585 14.152 13.0949 14.3008 13.2506C14.4494 13.406 14.6608 13.4959 14.9138 13.4959C15.1668 13.4959 15.3782 13.406 15.5268 13.2506Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_25 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5 19C16.366 19 19.5 15.866 19.5 12C19.5 8.13401 16.366 5 12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19ZM12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5049 14.8249C12.5794 14.8249 12.6478 14.7834 12.6822 14.7174C12.7167 14.6513 12.7116 14.5715 12.6689 14.5104L11.5856 12.9579C12.2305 12.5987 12.6041 11.9753 12.6041 11.1685C12.6041 10.5064 12.3553 9.95582 11.8977 9.57434C11.4443 9.19637 10.8054 9 10.0482 9H7.7C7.58954 9 7.5 9.08954 7.5 9.2V14.6249C7.5 14.7353 7.58954 14.8249 7.7 14.8249H8.95547C9.06593 14.8249 9.15547 14.7353 9.15547 14.6249V13.3137H10.0054L10.992 14.7387C11.0293 14.7927 11.0908 14.8249 11.1564 14.8249H12.5049ZM9.97845 10.423C10.3353 10.423 10.5712 10.5045 10.715 10.6251C10.8531 10.7411 10.9332 10.9158 10.9332 11.1685C10.9332 11.4166 10.8535 11.5919 10.7145 11.7092C10.5703 11.831 10.3343 11.9139 9.97845 11.9139H9.15547V10.423H9.97845Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.5133 10.4555V10.4915C14.8222 10.289 15.2006 10.1935 15.623 10.1935C16.2567 10.1935 16.8282 10.4207 17.2418 10.8343C17.6558 11.2483 17.9 11.8376 17.9 12.5402C17.9 13.2428 17.6558 13.832 17.2418 14.2461C16.8282 14.6596 16.2567 14.8869 15.623 14.8869C15.2262 14.8869 14.8685 14.7984 14.5676 14.6096V16.1283C14.5676 16.2388 14.478 16.3283 14.3676 16.3283H13.1586C13.0481 16.3283 12.9586 16.2388 12.9586 16.1283V10.4555C12.9586 10.345 13.0481 10.2555 13.1586 10.2555H14.3133C14.4238 10.2555 14.5133 10.345 14.5133 10.4555ZM16.2755 12.5402C16.2755 12.8576 16.1756 13.094 16.0268 13.2496C15.8782 13.405 15.6668 13.4949 15.4138 13.4949C15.1608 13.4949 14.9494 13.405 14.8008 13.2496C14.652 13.094 14.5521 12.8576 14.5521 12.5402C14.5521 12.2228 14.652 11.9864 14.8008 11.8308C14.9494 11.6753 15.1608 11.5855 15.4138 11.5855C15.6668 11.5855 15.8782 11.6753 16.0268 11.8308C16.1756 11.9864 16.2755 12.2228 16.2755 12.5402Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_29 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("path", {
  d: "M17.9055 3.27183L17.9055 3.27183C17.7425 2.93022 17.2562 2.93022 17.0932 3.27183L16.3241 4.88363L14.5535 5.11703C14.1783 5.16649 14.028 5.62895 14.3025 5.88954L15.5978 7.11908L15.2726 8.87513C15.2037 9.24731 15.5971 9.53312 15.9297 9.35257L17.4994 8.50067L19.069 9.35257C19.4016 9.53312 19.795 9.24731 19.7261 8.87513L19.401 7.11908L20.6962 5.88954C20.9707 5.62895 20.8205 5.16649 20.4452 5.11703L18.6746 4.88363L17.9055 3.27183ZM17.5232 8.48772C17.5232 8.48774 17.5232 8.48776 17.5231 8.48777L17.5232 8.48772ZM19.3813 7.13777L19.3814 7.13768L19.3813 7.13777Z",
  fill: "#1C54C5",
  stroke: "#1C54C5",
  "stroke-width": "0.5",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.8424 4.65351L18.1318 3.16416C17.8782 2.63278 17.1218 2.63278 16.8682 3.16416L16.1576 4.65351L14.5215 4.86917C13.9378 4.94612 13.704 5.66549 14.131 6.07085L15.3279 7.20698L15.0274 8.82962C14.9202 9.40856 15.5322 9.85315 16.0496 9.57229L17.5 8.78512L18.9504 9.57229C19.4678 9.85315 20.0798 9.40856 19.9726 8.82962L19.6721 7.20698L20.869 6.07085C21.296 5.66549 21.0622 4.94612 20.4785 4.86917L18.8424 4.65351ZM17.6805 3.37949C17.6081 3.22767 17.3919 3.22767 17.3195 3.37949L16.5387 5.01579C16.5095 5.07689 16.4515 5.11909 16.3843 5.12794L14.5868 5.36488C14.4201 5.38687 14.3533 5.5924 14.4753 5.70822L15.7902 6.95645C15.8393 7.00306 15.8615 7.07135 15.8492 7.13792L15.5191 8.92065C15.4884 9.08606 15.6633 9.21309 15.8111 9.13285L17.4046 8.268C17.4641 8.23571 17.5359 8.23571 17.5954 8.268L19.1889 9.13285C19.3367 9.21309 19.5116 9.08606 19.4809 8.92065L19.1508 7.13792C19.1385 7.07135 19.1607 7.00306 19.2098 6.95645L20.5247 5.70822C20.6467 5.5924 20.5799 5.38687 20.4132 5.36488L18.6157 5.12794C18.5485 5.11909 18.4905 5.07689 18.4613 5.01579L17.6805 3.37949Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("path", {
  d: "M12 5.00098C8.13401 5.00098 5 8.13498 5 12.001C5 15.867 8.13401 19.001 12 19.001C15.866 19.001 19 15.867 19 12.001C19 11.4487 19.4477 11.001 20 11.001C20.5523 11.001 21 11.4487 21 12.001C21 16.9715 16.9706 21.001 12 21.001C7.02944 21.001 3 16.9715 3 12.001C3 7.03041 7.02944 3.00098 12 3.00098C12.5523 3.00098 13 3.44869 13 4.00098C13 4.55326 12.5523 5.00098 12 5.00098Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.1822 14.7183C12.1478 14.7844 12.0794 14.8259 12.0049 14.8259H10.6564C10.5908 14.8259 10.5293 14.7937 10.492 14.7397L9.50541 13.3146H8.65547V14.6259C8.65547 14.7363 8.56593 14.8259 8.45547 14.8259H7.2C7.08954 14.8259 7 14.7363 7 14.6259V9.20098C7 9.09052 7.08954 9.00098 7.2 9.00098H9.5482C10.3054 9.00098 10.9443 9.19734 11.3977 9.57532C11.8553 9.9568 12.1041 10.5074 12.1041 11.1694C12.1041 11.9763 11.7305 12.5997 11.0856 12.9588L12.1689 14.5114C12.2116 14.5725 12.2167 14.6523 12.1822 14.7183ZM10.215 10.6261C10.0712 10.5054 9.83532 10.424 9.47845 10.424H8.65547V11.9149H9.47845C9.83432 11.9149 10.0703 11.8319 10.2145 11.7102C10.3535 11.5929 10.4332 11.4176 10.4332 11.1694C10.4332 10.9168 10.3531 10.7421 10.215 10.6261Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.0133 10.4925V10.4564C14.0133 10.346 13.9238 10.2564 13.8133 10.2564H12.6586C12.5481 10.2564 12.4586 10.346 12.4586 10.4564V16.1293C12.4586 16.2398 12.5481 16.3293 12.6586 16.3293H13.8676C13.978 16.3293 14.0676 16.2398 14.0676 16.1293V14.6106C14.3685 14.7994 14.7262 14.8879 15.123 14.8879C15.7567 14.8879 16.3282 14.6606 16.7418 14.2471C17.1558 13.833 17.4 13.2437 17.4 12.5412C17.4 11.8386 17.1558 11.2493 16.7418 10.8352C16.3282 10.4217 15.7567 10.1944 15.123 10.1944C14.7006 10.1944 14.3222 10.29 14.0133 10.4925ZM15.5268 13.2506C15.6756 13.0949 15.7755 12.8585 15.7755 12.5412C15.7755 12.2238 15.6756 11.9874 15.5268 11.8317C15.3782 11.6763 15.1668 11.5864 14.9138 11.5864C14.6608 11.5864 14.4494 11.6763 14.3008 11.8317C14.152 11.9874 14.0521 12.2238 14.0521 12.5412C14.0521 12.8585 14.152 13.0949 14.3008 13.2506C14.4494 13.406 14.6608 13.4959 14.9138 13.4959C15.1668 13.4959 15.3782 13.406 15.5268 13.2506Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_35 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 12C5 8.13401 8.13401 5 12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12ZM12.1822 14.7174C12.1478 14.7834 12.0794 14.8249 12.0049 14.8249H10.6564C10.5908 14.8249 10.5293 14.7927 10.492 14.7387L9.50541 13.3137H8.65547V14.6249C8.65547 14.7353 8.56593 14.8249 8.45547 14.8249H7.2C7.08954 14.8249 7 14.7353 7 14.6249V9.2C7 9.08954 7.08954 9 7.2 9H9.5482C10.3054 9 10.9443 9.19637 11.3977 9.57434C11.8553 9.95582 12.1041 10.5064 12.1041 11.1685C12.1041 11.9753 11.7305 12.5987 11.0856 12.9579L12.1689 14.5104C12.2116 14.5715 12.2167 14.6513 12.1822 14.7174ZM10.215 10.6251C10.0712 10.5045 9.83532 10.423 9.47845 10.423H8.65547V11.9139H9.47845C9.83432 11.9139 10.0703 11.831 10.2145 11.7092C10.3535 11.5919 10.4332 11.4166 10.4332 11.1685C10.4332 10.9158 10.3531 10.7411 10.215 10.6251ZM14.0133 10.4915V10.4555C14.0133 10.345 13.9238 10.2555 13.8133 10.2555H12.6586C12.5481 10.2555 12.4586 10.345 12.4586 10.4555V16.1283C12.4586 16.2388 12.5481 16.3283 12.6586 16.3283H13.8676C13.978 16.3283 14.0676 16.2388 14.0676 16.1283V14.6096C14.3685 14.7984 14.7262 14.8869 15.123 14.8869C15.7567 14.8869 16.3282 14.6596 16.7418 14.2461C17.1558 13.832 17.4 13.2428 17.4 12.5402C17.4 11.8376 17.1558 11.2483 16.7418 10.8343C16.3282 10.4207 15.7567 10.1935 15.123 10.1935C14.7006 10.1935 14.3222 10.289 14.0133 10.4915ZM15.5268 13.2496C15.6756 13.094 15.7755 12.8576 15.7755 12.5402C15.7755 12.2228 15.6756 11.9864 15.5268 11.8308C15.3782 11.6753 15.1668 11.5855 14.9138 11.5855C14.6608 11.5855 14.4494 11.6753 14.3008 11.8308C14.152 11.9864 14.0521 12.2228 14.0521 12.5402C14.0521 12.8576 14.152 13.094 14.3008 13.2496C14.4494 13.405 14.6608 13.4949 14.9138 13.4949C15.1668 13.4949 15.3782 13.405 15.5268 13.2496ZM14.2374 3.23913C14.5303 2.94623 15.0052 2.94623 15.2981 3.23913L16.2122 4.15321C16.3329 3.90086 16.5907 3.72656 16.8891 3.72656C17.3033 3.72656 17.6391 4.06235 17.6391 4.47656L17.6391 5.89078C17.6391 6.30499 17.3033 6.64078 16.8891 6.64078H15.4749C15.0607 6.64078 14.7249 6.30499 14.7249 5.89078C14.7249 5.59235 14.8992 5.33463 15.1515 5.21387L14.2374 4.29979C13.9445 4.00689 13.9445 3.53202 14.2374 3.23913ZM19.8943 9.95619C20.1872 10.2491 20.6621 10.2491 20.9549 9.95619C21.2478 9.66329 21.2478 9.18842 20.9549 8.89553L20.0409 7.98144C20.2932 7.86068 20.4675 7.60296 20.4675 7.30454C20.4675 6.89032 20.1317 6.55454 19.7175 6.55454H18.3033C17.8891 6.55454 17.5533 6.89032 17.5533 7.30454L17.5533 8.71875C17.5533 9.13296 17.8891 9.46875 18.3033 9.46875C18.6017 9.46875 18.8594 9.29445 18.9802 9.0421L19.8943 9.95619Z",
  fill: "#1C54C5"
}, null, -1)
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = {
  class: "flex-col flex p-4 bg-gray-lp-1000",
  style: {"border-bottom-right-radius":"0.75rem","border-bottom-left-radius":"0.75rem"}
}
const _hoisted_39 = { class: "flex flex-row items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold text-gray-lp-300 mr-2" }, ".", -1)
const _hoisted_41 = { class: "text-14px font-semibold text-gray-lp-300 mt-1" }
const _hoisted_42 = { class: "flex flex-row items-center" }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-semibold text-gray-lp-300 mr-2" }, ".", -1)
const _hoisted_44 = { class: "text-14px font-semibold text-gray-lp-300 mt-1" }
const _hoisted_45 = {
  key: 0,
  class: "flex mt-5 flex-col w-full border rounded-xl border-gray-lp-1400 pt-4 font-montserrat"
}
const _hoisted_46 = { class: "flex flex-col border-b border-gray-lp-1400 px-4 pb-5" }
const _hoisted_47 = { class: "text-20px text-gray-lp-300 font-bold" }
const _hoisted_48 = { class: "text-14px text-gray-lp-600 font-normal" }
const _hoisted_49 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('clientManagement.registrationFlow.priceCustomization')), 1),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.configurePriceTypePriceWeightAndInsuranceByClientNeed')), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createBlock("div", {
              style: 
              _ctx.isSelected(option) && !option.disabled
                ? 'background-color:#EBF8FF;'
                : `${
                    option.disabled
                      ? 'background-color:rgba(212, 213, 216, 0.50);'
                      : ''
                  }`
            ,
              class: 
              `w-full flex flex-col p-4 pb-3 border rounded-lg
            ${option.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
            ${
              _ctx.isSelected(option) ? 'border-blue-lp-300' : 'border-gray-lp-1400'
            }`
            ,
              onClick: 
              () => {
                if (!option.disabled) _ctx.selectOption(option);
              }
            ,
              key: option.value
            }, [
              _createVNode("div", _hoisted_8, [
                (option.disabled)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      (_ctx.isSelected(option))
                        ? (_openBlock(), _createBlock("svg", _hoisted_12, [
                            _hoisted_13,
                            _hoisted_14
                          ]))
                        : (_openBlock(), _createBlock("svg", _hoisted_15, [
                            _hoisted_16,
                            _hoisted_17
                          ]))
                    ]))
              ]),
              _createVNode("div", _hoisted_18, [
                (option.value === 'retail')
                  ? (_openBlock(), _createBlock("svg", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24
                    ]))
                  : _createCommentVNode("", true),
                (option.value === 'normal')
                  ? (_openBlock(), _createBlock("svg", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true),
                (option.value === 'khusus')
                  ? (_openBlock(), _createBlock("svg", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34
                    ]))
                  : _createCommentVNode("", true),
                (option.value === 'kombinasi')
                  ? (_openBlock(), _createBlock("svg", _hoisted_35, [
                      _hoisted_36
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("p", {
                  class: 
                  `text-center text-16px ${
                    option.disabled ? 'text-gray-lp-600' : 'text-gray-lp-300'
                  } font-bold`
                
                }, _toDisplayString(option.label), 3)
              ]),
              _createVNode("p", {
                class: 
                `font-normal text-12px ${
                  option.disabled ? 'text-gray-lp-600' : 'text-gray-lp-800'
                }  text-center mt-2`
              
              }, _toDisplayString(option.description), 3)
            ], 14, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _renderSlot(_ctx.$slots, "form")
      ]),
      _createVNode("div", _hoisted_38, [
        _createVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.priceFollowsRetailPrice')), 1)
        ]),
        _createVNode("div", _hoisted_42, [
          _hoisted_43,
          _createVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insuranceCalculationFollowsRetailTiering')), 1)
        ])
      ])
    ]),
    (_ctx.modelValue.isCustomRate !== 'retail')
      ? (_openBlock(), _createBlock("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("p", _hoisted_47, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.pricePeriod')), 1),
            _createVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.priceAppliesBasedOnSelectedPeriodDate')), 1)
          ]),
          _createVNode("div", _hoisted_49, [
            _renderSlot(_ctx.$slots, "periode")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}